import type * as React from 'react';
import { KpiCard } from '@redhand/ui';
import { PageIntro, StateSection } from '../ui-helpers.js';

export function KpiCardPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro title="KpiCard" lead="Hodnota + srovnání období + šipka (vzor kokpit reference). Peníze vždy formátované (Money), nikdy holé number." />
      <StateSection title="Řada KPI (grid z OverviewLayout)">
        <div className="rh-overview__kpis">
          <KpiCard
            icon={<span>🧾</span>}
            label="Tržby"
            value="145 500 Kč"
            delta={{ value: '12,25 %', direction: 'up', srLabel: 'nárůst o 12,25 % proti minulému období' }}
            caption="proti minulým 30 dnům"
          />
          <KpiCard
            icon={<span>📦</span>}
            label="Objednávky"
            value="436"
            delta={{ value: '3,1 %', direction: 'down', srLabel: 'pokles o 3,1 % proti minulému období' }}
            caption="proti minulým 30 dnům"
          />
          <KpiCard
            icon={<span>↩️</span>}
            label="Storna"
            value="9"
            delta={{ value: '18 %', direction: 'down', positive: true, srLabel: 'pokles storen o 18 % — pozitivní vývoj' }}
            caption="méně je lépe — pokles je zeleně"
          />
          <KpiCard icon={<span>👥</span>} label="Noví klienti" value="27" caption="bez srovnání (první období)" />
        </div>
      </StateSection>
      <StateSection title="Dlouhá čeština a velká čísla">
        <div className="rh-overview__kpis">
          <KpiCard
            label="Průměrná prodejní cena nemovitosti v Jihočeském kraji"
            value="7 250 000 Kč"
            delta={{ value: '2,4 %', direction: 'up', srLabel: 'nárůst o 2,4 %' }}
            caption="medián za posledních 90 dnů, zdroj: uzavřené transakce"
          />
        </div>
      </StateSection>
    </div>
  );
}
